import Main from 'controllers/Main';
import Screen from 'controllers/Screen';
import Scroll from 'controllers/Scroll';
import AbstractView from "abstracts/AbstractView";
import TransitionController from "controllers/TransitionController";


export default class TOC extends AbstractView {

	constructor($wrapper) {
		super();
		this.$wrapper = $wrapper;
		this.scrollLimits = [];
		this.prevLimit = -1;
		this.currentIndex = false;
		this.margin = 300;
		this.max = Screen.wH;
		this.visible = false;
		this.init();
	}


	init() {
		super.init();
		this.resize();
	}


	initDOM() {
		this.$content = Main.$pageWrap.find('.page_content-inner');
		this.$links = this.$wrapper.find('.project_toc-link');
	}


	bindEvents() {
		this.eh.linkClickHandler = this._linkClick.bind(this);
		this.$links.on('click', this.eh.linkClickHandler);

		Main.on(Main.E.RAF, this.raf, this);
		Screen.on(Screen.E.RESIZE, this.resize, this);
		TransitionController.once(TransitionController.E.TRANSITION_COMPLETE, this.resize, this);
	}


	unbindEvents() {
		this.$links.off('click', this.eh.linkClickHandler);
		Main.off(Main.E.RAF, this.raf, this);
		Screen.off(Screen.E.RESIZE, this.resize, this);
		super.unbindEvents();
	}


	_linkClick(event) {
		event.preventDefault();
		const $target = document.querySelector(event.currentTarget.getAttribute('href'));
		Scroll.scrollTo($target, 'smooth');
	}


	raf() {
		if (this.visible === true && Scroll.yI > this.max) {
			this.visible = false;
			this.$wrapper.addClass('hidden');
			this.$links.removeClass('active');
			this.currentIndex = -1;
		} else if (this.visible === false && Scroll.yI <= this.max) {
			this.visible = true;
			this.$wrapper.removeClass('hidden');
		}
		if (!this.visible) {
			return;
		}
		const limit = Scroll.yI + this.margin;
		if (limit === this.prevLimit) {
			return;
		}
		this.prevLimit = limit;
		let currentIndex = false;
		for (let i = 0; i < this.scrollLimits.length; i++) {
			if (this.scrollLimits[i] < limit) {
				currentIndex = i;
			}
		}


		if (this.currentIndex === currentIndex) {
			return;
		}

		this.currentIndex = currentIndex;

		this.reset();

		// If an index is found
		if (currentIndex !== false) {
			const $active = this.$links.eq(this.currentIndex);
			$active.addClass('active');
		}
	}


	reset() {
		this.prevLimit = -1;
		this.visible = true;
		this.$links.removeClass('active');
		this.$links.removeClass('hidden');
	}


	resize() {
		this.max = this.$content.outerHeight() - (Screen.wH * 1.3);
		this.margin = Screen.wH * 0.5;
		this.scrollLimits = [];
		this.$links.each((index, item) => {
			const targetID = item.getAttribute("href");
			if (targetID === '' || targetID === '#') {
				return;
			}
			const $target = document.querySelector(targetID);
			let cbr;
			if ($target) {
				cbr = $target.getBoundingClientRect();
			} else {
				return;
			}
			this.scrollLimits.push(cbr.top + Scroll.y);
		});
		this.reset();
	}


}

